import { FormsManager } from "./FormsManager.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  FormsManager
};
//# sourceMappingURL=index.js.map
